export enum LotTemplateExportType {
    LOT_CREATION = 'LOT_CREATION',
    LOT_UPDATE = 'LOT_UPDATE',
    LOT_UPDATE_BALANCE = 'LOT_UPDATE_BALANCE'
}
